import { createReducer, createActions } from 'reduxsauce';
import Immutable from 'seamless-immutable';

export const INITIAL_STATE = Immutable({
  isLoading: false,
  successMessage: null,
  errorMessage: null,
  users: [],
  totalElements: 0,
  createdId: null,
  createdAddressId: null,
});

const { Types, Creators } = createActions({
  getUsersRequest: ['customerId', 'pageParams'],
  getUsersRequestSuccess: ['users', 'totalElements'],
  getUsersRequestFailure: ['errorMessage'],

  createUserRequest: ['userInfos', 'customerId', 'pageParams', 'url'],
  createUserRequestSuccess: ['createdId', 'createdAddressId', 'users', 'totalElements', 'successMessage'],
  createUserRequestFailure: ['errorMessage'],

  editUserRequest: ['userInfos', 'customerId', 'pageParams'],
  editUserRequestSuccess: ['users', 'totalElements', 'successMessage'],
  editUserRequestFailure: ['errorMessage'],

  deleteUserRequest: ['username', 'customerId', 'pageParams'],
  deleteUserRequestSuccess: ['users', 'totalElements', 'successMessage'],
  deleteUserRequestFailure: ['errorMessage'],

  resetUsers: null,
});

export const getUsersRequest = (state) => state.merge({ isLoading: true, successMessage: null, errorMessage: null });
export const getUsersRequestSuccess = (state, { users, totalElements }) =>
  state.merge({ isLoading: false, users, totalElements });
export const getUsersRequestFailure = (state, { errorMessage }) => state.merge({ isLoading: false, errorMessage });

export const createUserRequest = (state) => state.merge({ isLoading: true, successMessage: null, errorMessage: null });
export const createUserRequestSuccess = (
  state,
  { createdId, createdAddressId, users, totalElements, successMessage }
) => state.merge({ isLoading: false, createdId, createdAddressId, users, totalElements, successMessage });
export const createUserRequestFailure = (state, { errorMessage }) => state.merge({ isLoading: false, errorMessage });

export const editUserRequest = (state) => state.merge({ isLoading: true, successMessage: null, errorMessage: null });
export const editUserRequestSuccess = (state, { users, totalElements, successMessage }) =>
  state.merge({ isLoading: false, users, totalElements, successMessage });
export const editUserRequestFailure = (state, { errorMessage }) => state.merge({ isLoading: false, errorMessage });

export const deleteUserRequest = (state) => state.merge({ isLoading: true, successMessage: null, errorMessage: null });
export const deleteUserRequestSuccess = (state, { users, totalElements, successMessage }) =>
  state.merge({ isLoading: false, users, totalElements, successMessage });
export const deleteUserRequestFailure = (state, { errorMessage }) => state.merge({ isLoading: false, errorMessage });

export const resetUsers = (state) => state.merge({ users: [], totalElements: 0 });

export const reducer = createReducer(INITIAL_STATE, {
  [Types.GET_USERS_REQUEST]: getUsersRequest,
  [Types.GET_USERS_REQUEST_SUCCESS]: getUsersRequestSuccess,
  [Types.GET_USERS_REQUEST_FAILURE]: getUsersRequestFailure,

  [Types.CREATE_USER_REQUEST]: createUserRequest,
  [Types.CREATE_USER_REQUEST_SUCCESS]: createUserRequestSuccess,
  [Types.CREATE_USER_REQUEST_FAILURE]: createUserRequestFailure,

  [Types.EDIT_USER_REQUEST]: editUserRequest,
  [Types.EDIT_USER_REQUEST_SUCCESS]: editUserRequestSuccess,
  [Types.EDIT_USER_REQUEST_FAILURE]: editUserRequestFailure,

  [Types.DELETE_USER_REQUEST]: deleteUserRequest,
  [Types.DELETE_USER_REQUEST_SUCCESS]: deleteUserRequestSuccess,
  [Types.DELETE_USER_REQUEST_FAILURE]: deleteUserRequestFailure,

  [Types.RESET_USERS]: resetUsers,
});

export const UsersTypes = Types;
export default Creators;
